module.exports = __webpack_public_path__ + "img/forecasting-senate-model.a0c5eb04.png";